// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"0a894e40","264":"6a7a9204","953":"232c4751"}[chunkId] + ".chunk.css";
};